import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  gap: 8,
  alignItems: 'center',

  '& .MuiTextField-root': {
    flexGrow: 1,
    '& .MuiInputBase-root input': {
      padding: '4px 8px',
    },
  },

  '& .MuiButton-root': {
    minWidth: 'min-content',
    padding: 4,
    width: 20,
    height: 20,
    '& svg': {
      fontSize: 16,
    },
  },

});

export default StyledBox;
